(function ($) {

    $.fn.combobox = function (options) {
        // build main options before element iteration
        options = $.extend(true, {}, $.fn.combobox.defaults, options);

        return this.each(function () {
            var $jqxCombobox = $(this);
            var form = $jqxCombobox.closest('form');

            // build element specific options
            $jqxCombobox.options = $.metadata ? $.extend(true, {}, options, $jqxCombobox.metadata()) : options;
            $jqxCombobox.options = $.fn.dataset ? $.extend(true, $jqxCombobox.options, $jqxCombobox.dataset()) : $jqxCombobox.options;

            var width;
            if ($jqxCombobox.is(':visible')) {
                width = $jqxCombobox.width() - 9;
            } else {
                // if the select is hidden then the width will not calculate correctly, but using the closest visible container should be a reasonable estimate (e.g. might be a td)
                width = $jqxCombobox.closest(':visible').width();
            }

            //build properties
            var properties = {
                theme: 'trackit',
                width: width,
                height: 21,
                itemHeight: 18,
                multiSelect: true,
                dropDownHeight: 360,
                scrollBarSize: 10,
                placeHolder: $jqxCombobox.options.placeHolder,
                autoDropDownHeight: true,
                renderSelectedItem: $jqxCombobox.options.renderSelected
            };

            $jqxCombobox.jqxComboBox(properties);

            var selectId = $jqxCombobox.options.selectId;
            $jqxCombobox.jqxComboBox('loadFromSelect', selectId);

            $.each($jqxCombobox.jqxComboBox('getItems'), function(idx, item){
               if (item !== undefined && item.label.length > 40) {
                   var index = item.index;
                   $jqxCombobox.jqxComboBox('removeAt', index);
                   $jqxCombobox.jqxComboBox('insertAt', {label:item.label.substring(0,40) + "...", value:item.value}, index);
               }
            });

            $jqxCombobox.closest('.combobox-div').find('#' + selectId + ' option').each(function() {
                var $select = $(this);
                if ($select.attr('selected')) {
                    $jqxCombobox.jqxComboBox('selectItem', $jqxCombobox.jqxComboBox('getItemByValue', $select.val()));
                }
            });

            //bind hidden input
            syncHidden();

            function syncHidden() {
                var $hidden = $jqxCombobox.parent('.combobox-div').find('.combobox-hidden-input');
                var items = $.map($jqxCombobox.jqxComboBox('getSelectedItems'), function (item) {
                    return item.value;
                });
                $hidden.val(items.join(','));
            }

            $jqxCombobox.on('select unselect', function() {
                syncHidden();
            });

            //set remote search url and event handler.
            //built-in remote search combine with multi select is not supported http://www.jqwidgets.com/community/topic/3-0-0-multi-remote-search/
            var $textInput = $jqxCombobox.find('.jqx-combobox-input');
            var url = $jqxCombobox.options.remoteSearchUrl;
            if (url) {
                $textInput.on('keyup', function(){
                    delay(remoteSearch, $jqxCombobox.options.remoteSearchDelay);
                });
            }

            var delay = (function(){
                var timer = 0;
                return function(callback, ms){
                    clearTimeout (timer);
                    timer = setTimeout(callback, ms);
                };
            })();

            /**
             * remote search with the given input and any dependant values.
             */
            function remoteSearch() {
                var val = $textInput.val();
                var searchVal = $textInput.data('searchVal');
                if (val !== undefined && val.length > 1 && (searchVal == undefined || val !== searchVal)) {

                    var params = {};
                    var dependant = $jqxCombobox.metadata().dependant;
                    $.each(dependant, function (idx, item) {
                        var paramElement = item.beginsWith("#") ? $(item, form) : $("[name='" + item + "']", form);
                        if (paramElement.length == 1) {
                            var val = paramElement.val();
                            params[item.beginsWith("#") ? item.substring(1) : item] = val || '';
                        }
                    });

                    /**
                     * If the search result is grouped, then send the current selected items
                     * back to the server so the final results displaying in the combo box can be properly grouped.
                     * Otherwise we might end with duplicates groups (one with the selected items already and one with the returning result)
                     */
                    var groupSearchResult = $jqxCombobox.metadata().groupSearchResult;
                    if (groupSearchResult) {
                        params["idSelectedItems"] = $.map($jqxCombobox.jqxComboBox('getSelectedItems'), function (item) {
                            return item.value;
                        }).join(',');
                    }

                    params["searchString"] = val || '';
                    $jqxCombobox.addClass('jqx-combobox-state-search-trackit');

                    $textInput.data('searchVal', val);
                    $.ajax({
                        url: url,
                        data: params,
                        dataType: 'json',
                        traditional: true,
                        success: function(data) {
                            var search = $textInput.data('searchVal');
                            //Only refresh and show the result if current search is the latest search.
                            if(val == search) {
                                //Capture the input before refresh because refresh combo box will clear the input field.
                                var currentVal = $textInput.val();
                                var currentWidth = $textInput.width();
                                refreshComboBox(data, groupSearchResult);
                                focusComboBoxInput($textInput, currentVal, currentWidth);
                                $jqxCombobox.removeClass('jqx-combobox-state-search-trackit');
                            }
                        }
                    });
                }
            }

            function focusComboBoxInput($input, val, width) {
                // width of input is set by combobox according to content, but is reset when refreshComboBox is called, so restore here
                $input.width(width);
                $input.val(val);
                // need small delay on focus, otherwise it does not work in IE
                setTimeout(function() { $input.focus(); }, 10);
            }

            /**
             * 1. keep the items that are already selected
             * 2. populate the drop down with the data from server.
             * 3. do not populate the items from server that are already in the combo box.
             */
            function refreshComboBox(data, groupSearchResult) {
                var existingItems = $jqxCombobox.jqxComboBox('getSelectedItems');
                // will be undefined if combobox no longer exists
                if (existingItems != undefined) {

                    var newItems = []; //new items to populate the combo box.
                    var existingItemsArray = [];
                    if (!groupSearchResult) {
                        //push the selected items in this combo box into the array
                        existingItemsArray = $.map(existingItems, function (item) {
                            //Get rid of the group for selecte items so that
                            //the users returned from server can display group information properly.
                            newItems.push({label:item.label, value:item.value});
                            return item.value;
                        });
                    }

                    $jqxCombobox.data('refreshing', true);
                    $jqxCombobox.jqxComboBox('clear');

                    //push the items from server into the array, filter out the items that are already selected.
                    $.each(data.listItems, function (idx, item) {
                        if ($.inArray(item.value, existingItemsArray) == -1) {
                            //exclude the items already in the combo
                            if (item.name.length > 40) {
                                newItems.push({label: item.name.substring(0,40) + "...", value: item.value, group:item.group});
                            } else {
                                newItems.push({label: item.name, value: item.value, group: item.group});
                            }
                        }
                    });

                    $jqxCombobox.jqxComboBox('source', newItems);
                    $jqxCombobox.jqxComboBox({autoDropDownHeight: newItems.length < 21});

                    //re-select the items that are already selected.
                    $.each(existingItems, function (i, item) {
                        $jqxCombobox.jqxComboBox('selectItem', $jqxCombobox.jqxComboBox('getItemByValue', item.value));
                    });

                    $jqxCombobox.data('refreshing', false);
                    $jqxCombobox.jqxComboBox('open');
                }
            }
        });
    };

    //
    // plugin defaults
    //
    $.fn.combobox.defaults = {
        remoteSearchDelay:400,
        renderSelected: function(index, item){
            if (item !== undefined) {
                return item.label;
            }
        }
    };

})(jQuery);